module.exports = __webpack_public_path__ + "static/media/letter(white).788128cc.svg";